import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { cn } from "@/lib/utils";
function FullScreenMenuConsumer({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-6 items-center justify-center animate-pulse">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-32 bg-muted/20 rounded-md" />)}
      </div>;
  }
  return <nav className="flex flex-col items-center justify-center gap-8">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="text-3xl md:text-5xl font-serif font-medium text-foreground hover:text-primary transition-colors duration-300" onClick={onClose} data-index={i}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);
  return <header id="header" className={cn("dark fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-in-out border-b border-transparent", isScrolled ? "bg-background/80 backdrop-blur-md py-3 border-border/10 shadow-sm" : "bg-background py-5")}>
      <div className="container mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between relative">
          {}
          <div className="flex-1 flex justify-start">
            <Button variant="ghost" size="icon" onClick={() => setIsMenuOpen(true)} className="hover:bg-accent/10 text-foreground" aria-label="Apri menu">
              <Menu className="size-6" />
            </Button>
          </div>

          {}
          <div className="flex-0">
            <Link to="/" className="block">
              <img src="/img/optical_bench_logo.png" alt="italian minuteros" className="h-7 w-auto object-contain opacity-90" />
            </Link>
          </div>

          {}
          <div className="flex-1 flex justify-end">
            <Button asChild className="hidden md:inline-flex rounded-none border border-primary bg-transparent text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 uppercase tracking-wider text-xs font-medium px-6">
              <Link to="/ContactPage">Book an Experience</Link>
            </Button>
            {}
            <Button asChild size="sm" className="md:hidden rounded-none text-xs px-3">
              <Link to="/ContactPage">BOOK AN EXPERIENCE</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className={cn("fixed inset-0 z-[60] bg-background/95 backdrop-blur-xl flex flex-col items-center justify-center transition-all duration-500 ease-in-out", isMenuOpen ? "opacity-100 pointer-events-auto visible" : "opacity-0 pointer-events-none invisible")}>
        {}
        <Button variant="ghost" size="icon" onClick={() => setIsMenuOpen(false)} className="absolute top-6 left-4 md:left-8 text-foreground hover:bg-accent/10" aria-label="Chiudi menu">
          <X className="size-8" />
        </Button>

        {}
        <div className="w-full max-w-3xl px-6 text-center">
          <MenuProvider menu_id="35" className="w-full">
            <FullScreenMenuConsumer onClose={() => setIsMenuOpen(false)} />
          </MenuProvider>

          
        </div>
      </div>
    </header>;
}